import { render, staticRenderFns } from "./ReportPurchases.vue?vue&type=template&id=2db191fe&scoped=true&"
import script from "./ReportPurchases.vue?vue&type=script&lang=js&"
export * from "./ReportPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db191fe",
  null
  
)

export default component.exports